import * as React from "react";
import styled from "styled-components";

import { Metrics, Palette } from "../../vars";

const MobileToolbarToggle: React.SFC<any> = ({ className, onClick }) => (
  <button className={className} onClick={onClick} aria-label="navigation">
    <i className="md-icon">menu</i>
  </button>
);

export default styled(MobileToolbarToggle)`
  border: none;
  background: none;
  height: 100%;
  line-height: ${Metrics.LineHeights.MOBILE_TOOLBAR_BUTTON}px;
  padding: 0 19px;
  margin-left: 64px;
  border-right: 1px solid ${Palette.Rebrand.Colours.G2};
  text-align: center;
  height: 64px;

  .style--rebrand & {
    &:hover {
      i {
        color: ${Palette.Rebrand.Colours.P2};
      }
    }

    i {
      color: ${Palette.Rebrand.Colours.G6};
      margin: 0;
      font-size: 36px;
    }
  }
`;
